<div class="import-container" [ngClass]="{'--theme-unico': customItem?.kind !=='collaborators'}">
  <div *ngIf="customItem?.kind !=='collaborators'" class="import-container__header">
    <h2>Importação de {{customItem?.text}}s</h2>
  </div>
  <div class="import-container__content">
    <ng-container *ngIf="error$ | async as errorRequest else upload">
      <div class="file-upload-status --error" [ngClass]="{'--theme-unico': customItem?.kind !=='collaborators'}">
        <!-- importação com erro na planilha -->
        <div *ngIf="errorRequest?.error?.code === 20">
          <p class="file-upload-status__content__title">
            Não conseguimos carregar a planilha por que ela excede o tamanho máximo de 10MB
          </p>
          <p class="file-upload-status__content__description">
            Certifique-se de que o tamanho da planilha não exceda 10MB e tente enviar novamente.
          </p>
        </div>
        <!-- Formato não aceito -->
        <div *ngIf="errorRequest?.error?.code === 19">
          <p class="file-upload-status__content__title">
            Não conseguimos carregar a planilha por que o formato está inválido
          </p>
          <p class="file-upload-status__content__description">
            Verifique se o formato da planilha está em
            <strong>.XLSX </strong> e envie novamente.
          </p>
        </div>
        <div
          *ngIf="errorRequest?.error?.code === 21 ||
            errorRequest?.error?.code === 22 ||
            errorRequest?.error?.code === 34 ||
            errorRequest?.error?.code === 35"
        >
          <!-- importação com erro na planilha -->
          <p class="file-upload-status__content__title">
            Não conseguimos carregar a planilha por que o nome da coluna foi alterado
          </p>
          <p class="file-upload-status__content__description">
            A planilha que você enviou não corresponde com a formatação da
            planilha modelo. Por favor, verifique a planilha e envie novamente.
          </p>
        </div>
        <button
          *ngIf="errorRequest?.status === 400"
          (click)="emitterCancel()"
          class="import-container__button --primary"
          data-test="btnRetryUpload"
        >
          Enviar planilha novamente
        </button>
        <a
          *ngIf="errorRequest?.status === 400"
          class="import-container__button --ghost"
          [href]="customItem?.urlModel"
          data-test="linkSpreadSheetTemplate"
          download
          (click)="trackEvents('import_download_after_error')"
        >
          Baixar planilha modelo
        </a>
        <div
          *ngIf="errorRequest?.status !== 400 ||
          !errorRequest?.status"
        >
          <p class="file-upload-status__content__title">
            Falha no envio
          </p>
          <p class="file-upload-status__content__description">
            O arquivo não pode ser importado porque houve uma falha no envio.
            Por favor, verifique a sua conexão ou tente novamente em alguns minutos.
          </p>
          <button
            (click)="emitterCancel()"
            class="import-container__button --primary"
            data-test="btnRetryUpload"
          >
            Tente novamente
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #upload>
      <ng-container *ngIf="preview$ | async as preview else uploadTemplate">
        <div
          *ngIf="preview?.protocolNumber"
          class="file-upload-status --success"
          [ngClass]="{'--theme-unico': customItem?.kind !=='collaborators'}"
        >
          <!-- importação com sucesso -->
          <div>
            <p class="file-upload-status__content__title">
              Importação iniciada com sucesso
            </p>
            <p class="file-upload-status__content__description">
              Agora é só aguardar! O processamento deste arquivo pode levar de
              alguns minutos a várias horas.
            </p>
            <p class="file-upload-status__content__description">
              Se preferir acompanhar, acesse a página de status de processamento
              clicando no botão abaixo
            </p>
            <a
              class="import-container__button --primary"
              data-test="linkProcessingStatus"
              href="{{collaboratorUrl + '/processing-status'}}"
              aria-label="Ir status de processamento."
            >
              Ver status de processamento
            </a>
          </div>
        </div>
      </ng-container>
      <ng-template #uploadTemplate>
        <div *ngIf="!uploading else loadingUpload">
          <div class="wrapper-upload">
            <div
              class="wrapper-upload wrapper-upload__steps --draggable"
              [class.--hovered]="hovering"
              [class.--loading]="uploading"
              draggable
              upDragAndDrop
              (filesDropped)="uploadFile($event)"
              (fileHover)="hoveredDropzone($event)"
            >
              <div class="wrapper-upload__steps__title">
                <label
                  (click)="trackEvents('import_send')"
                  data-test="labelUploadFile"
                  for="choose-upload"
                  class="import-container__button --link"
                >
                  Clique para carregar
                </label>
                <input
                  id="choose-upload"
                  data-test="btnUploadFile"
                  type="file"
                  name="choose-upload"
                  accept=".xlsx"
                  (change)="manuallyUpload($event)"
                >
                <p>
                  ou arraste e solte a planilha aqui
                </p>
              </div>
            </div>
            <div class="wrapper-upload__steps --static">
              <div class="wrapper-upload__steps__content">
                <div>
                  <div class="wrapper-upload__steps__icon">
                    <img
                      src="./assets/images/collaborators/icon-microsoft-excel.svg"
                      alt="Icone Microsoft Excel"
                    >
                    <p>Planilha modelo</p>
                  </div>
                  <p>
                    Preparamos uma planilha modelo para te ajudar a preencher as
                    informações dos colaboradores corretamente. Baixe agora!
                  </p>
                </div>
                <div>
                  <a
                    class="import-container__button --ghost"
                    href="./assets/files/collaborators/planilha_modelo_unico.xlsx"
                    download="planilha_modelo_unico.xlsx"
                    (click)="trackEvents('import_download')"
                  >
                    Baixar planilha modelo
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #loadingUpload>
          <div class="loading">
            <span class="circle">
            </span>
            <p class="loading__description">Importando colaboradores...</p>
          </div>
        </ng-template>
      </ng-template>
    </ng-template>
  </div>
</div>
